import {store} from 'Store/store.index';
import {isMobile} from 'Utils/device';
import React, { Component,lazy } from 'react'
import * as APP_CONSTANTS from 'Constants/app.constant';
import { convertController, fileController, preferenceFullScreenController } from "../Controllers/index";
import DrivesListDlg from 'Components/dialogs/DrivesListDlg/DrivesListDlg'
import PrivateDrives from 'Components/private_drives/PrivateDrives'
import OpenFile from 'Components/dialogs/OpenSaveCombine/Open/OpenFile'
import SaveFile from 'Components/dialogs/OpenSaveCombine/Save/SaveFile'
import Drives from 'Components/drives_panel/Drives'
import intl from 'react-intl-universal';
import {Modal } from 'antd';
import { observer, inject } from 'mobx-react'
import { getFileBufferByUrl, DATA_TYPE, FileData, convertApis, download } from 'Api/index';
import {
  CONVERT_MAP, HOME_OCR_QUICK_RECOGNITION,
} from 'Components/viewer/ui/constants/convert.constants';
import {ContextForCombineFiles} from '../context/combine_files'
import {
  TemplateDialog
} from '../../dialogs/index';
import {
  isCNDomain, isJPDomain
 } from 'Utils/utils';
 import {
  CONVERT_MUL_FILES_TO_PDF,
  CONVERT_TO_PDF_SETTINGS,
  CONVERT_FILES_TO_PDF,
  CREATE_BLANK_PDF,
  CONVERT_CLIPBOARD_TO_PDF,
  CONVERT_HTML_TO_PDF,
  CONVERT_NEW_PORTFOLIO,
  CONVERT_BLANK_PORTFOLIO,
  CONVERT_COMBINE_FILES,
  CONVERT_FROM_TEMPLATE,
  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_PDF_TO_WORD_2003,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_ACCESSIBLE_TXT,
  CONVERT_PDF_TO_HTML,
  CONVERT_PDF_TO_XML_STARDARD,
  OCR_QUICK_RECOGNITION,
  CONVERT_PREFLIGHT,
} from "../ui/constants/convert.constants";
  import {
    SAVE_TO_LOCAL,
    SAVE_TO_DOWNLOAD,
    SAVE_TO_GOOGLE_DRIVE,
    SAVE_TO_ONE_DRIVE,
    SAVE_TO_BOX,
    SAVE_TO_DROPBOX,
    SAVE_TO_DRIVES,
    SAVE_TO_PRIVATE_DRIVE,
    SAVE_AS_FILE,
    SAVE_TO_FILE_CLASS,
    SAVE_TO_GOOGLE_DRIVE_CLASS,
    SAVE_TO_LOCAL_CLASS,
    SAVE_TO_ONE_DRIVE_CLASS,
    SAVE_TO_BOX_CLASS,
    SAVE_TO_DROPBOX_CLASS, SAVE_FILE_BTN_HIDDEN_SLOT, SAVE_TO_IMANAGE,
  } from '../ui/constants/savefile.constants';
  import {GOOGLE_DRIVE, ONE_DRIVE, BOX, DROP_BOX, iManage} from 'Api/drives.constants'
  import {
    FILE_TAB_TRUST_MANAGER,
    FILE_TAB_FILE_PREFERENCES,
    FILE_TAB_FILE_PROPERTIES,
    FILE_TAB_PDF_OPTIMIZER,
  } from "../ui/constants/file.constants";
  import {
    DOCUMENT_LOADED,
    DOCUMENT_LOAD_FAILED,
    DOCUMENT_SAVED,
    //DOCUMENT_DURATION,
    //DOCUMENT_SAVE_FAILED,
  } from 'Components/viewer/ui/constants/event.constants';
import wrapDialog from '@/routes/wrapperDialog';
import {DialogContainer, DLG_TARGETS} from '../EditorDialogsContainer'

const ConvertToPDFDlg=lazy(()=>import('Components/dialogs/ConvertToPDF/ConvertToPDF.dialog'))
const CombineFiles=lazy(()=>import('Components/dialogs/OpenSaveCombine/Combine/CombineFiles'))
const MulFiles=lazy(()=>import('Components/dialogs/MulFilesToPDF/Multiple/MulFiles'))
const BrokenFileDlg=lazy(()=>import('Components/dialogs/BrokenFileDlg/BrokenFileDlg'))

let createBlankPageThrottle = false
type Props = {
  onClickCallback: any;
  containerCallbacks:any;
  CombineFilesTitle:string;
};
type State = {
  isShowConvertToPDFDlg: boolean; 
  isShowMulFiles2PDFDlg: boolean;
  isShowCombineFilesDlg: boolean;
  isShowBrokenFileDlgForCombine:boolean
  messageDlgCfg:any;
  brokenFileList:any;
  isShowPreflightDlg:boolean;
};

  
@inject('appStore', 'driveStore', 'privateDriveStore', 'taskStore', 'userStore', 'collaborationStore')
@observer
export default class ConvertTab extends React.Component<Props, State> {

  pdfui: any;
  CombineFilesTitle:string;
  state: State ={isShowConvertToPDFDlg:false, isShowMulFiles2PDFDlg:false, messageDlgCfg:{},
    isShowCombineFilesDlg:false, isShowBrokenFileDlgForCombine:false,brokenFileList: [],
    isShowPreflightDlg:false,
  };

    constructor(props) {
        super(props);
        this.CombineFilesTitle = intl.formatMessage({id: 'CombineFiles.Modal.Title'});
        store.appStore.setConvertHtml2PDFFn(this.onOkByHtml2PDFDlg);
        store.appStore.setOnAddCurrentDocForCombineFilesFn(this.onAddCurrentDocForCombineFiles);
        store.appStore.setOnAddDocForCombineFilesFn(this.onAddDocForCombineFiles);
        store.appStore.setOnCovertFileForPreviewFn(this.onCovertFileForPreview);
        store.appStore.setOnCloseMulFilesDlgFn(this.onCloseCombineFilesDlg);
    }

    componentDidMount(): void {
      // TODO FOXIT 云编辑处理 to-word/to-excel/to-ppt，不在此处处理
      const actions = {
        [CONVERT_TO_PDF_SETTINGS]:()=>{ this.setState({ isShowConvertToPDFDlg: true });},
        [CONVERT_FILES_TO_PDF]:({btnName, result, willDoFn})=>{
          {
            if(result.type === 'application/pdf'){
              window.onShowToSaveBeforeOpen((isToSave)=>{
                let fileName = result.name;
                !isToSave && store.appStore.doUpdateDocModified(false);
                // is true, do not open new file
                !isToSave && (window.pdfui.openPDFByFile(result, { fileName }).then(() => {}));
              })
              return;
            }
            convertController.doConvertToPDF(
              result,
              (result) => {
                store.docStore.setDocDriveName("")
                this.props.containerCallbacks.onHandlePDFByResponse(result, () => {
                  store.appStore.doUpdateDocModified(true)
                });
              },
              (/*err*/) => {},
            );
          }
        },
        [CREATE_BLANK_PDF]:()=>{
          const { isFromSharePoint } = store.appStore.sharePointInfo

          if(isFromSharePoint) {
            store.driveStore.leaveSharePointEditMode()
          }
  
          this.onClickCreateBlankPdfToOpen();
        },
        [CONVERT_CLIPBOARD_TO_PDF]:this.onClickClipboard2PdfToOpen,
        [CONVERT_HTML_TO_PDF]: this.onShowHtml2PDFDlg,
        [CONVERT_MUL_FILES_TO_PDF]: this.onShowMulFiles2PDFDlg,
        [CONVERT_NEW_PORTFOLIO]: ({result})=>{
            store.accountStore.updateTrialPermission(CONVERT_NEW_PORTFOLIO);
            this.onClickCreatePortfolioToOpen(result);     
        },
        [CONVERT_BLANK_PORTFOLIO]: ({result})=>{
          {
            store.accountStore.updateTrialPermission(CONVERT_BLANK_PORTFOLIO);
            this.onClickCreatePortfolioToOpen(result);
          }
        },
        [CONVERT_COMBINE_FILES]: this.onShowCombineFilesDlg,
        [CONVERT_FROM_TEMPLATE]: this.onShowFromTemplateDlg,
        [CONVERT_EXPORT_IMAGES]: ({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        // [CONVERT_PDF_TO_WORD]: ({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_XML_SPREADSHEET_2003]: ({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_WORD_2003]: ({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        // [CONVERT_PDF_TO_EXCEL]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        // [CONVERT_PDF_TO_PPT]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_PNG]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_JPEG]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_JPEG2000]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_TIFF]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_BMP]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_RTF]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_TXT]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_ACCESSIBLE_TXT]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_HTML]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [CONVERT_PDF_TO_XML_STARDARD]:({btnName}) =>this.props.containerCallbacks.onShowSaveAsDlg(btnName),
        [HOME_OCR_QUICK_RECOGNITION]: () => this.quickRecognitionHandler(),
        [OCR_QUICK_RECOGNITION]: () => this. quickRecognitionHandler(),
        [CONVERT_PREFLIGHT]:this.onShowPreflightDlg,
      };
      const {setupViewerActionCallback} = this.props.containerCallbacks;
      Object.keys(actions).map(name => {
        setupViewerActionCallback(name, actions[name]);
      })

      store.appStore.addAppEventListener('actionConvert', ({ action, args }) => {
        const fn = actions[action];
        fn && fn(args);
      });
    }

    quickRecognitionHandler = () => {
        const loopAlert = function(exprFunction) {
          window.pdfui.alert({
            id: 'OCR_QUICK_RECOGNITION' + Date.now(),
            again: intl.get('quickRecognition.alert.againText'),
            message: intl.get('quickRecognition.alert.content'),
            level: 'warning',
          }).then(isNotAgain => {
            !isNotAgain && exprFunction() && loopAlert(exprFunction);
          });
        };
        let storageData = localStorage.getItem('RECOGINIZE-TEXT-DATA');
        const {
          languages = [],
          findAll = false,
          textType = 2,
          recognize = false,
        } = storageData ? JSON.parse(storageData) : {};
        convertController.doConvertScannedDocument({
          fileBuffer: null,
          pageRange: null,
          languages: languages.join(','),
          is_editable: textType === 2,
          to_find_all_suspects: findAll,
          to_recognize_line_as_path: recognize,
          can_do_ocr: true,
        }, result => {
          let disablePages = result.data.disablePage;
          disablePages = (disablePages && disablePages.split(',')) || [];
          if (disablePages.length > 0) {
            let index = 0;
            loopAlert(() => {
              index += 1;
              return disablePages[index] !== undefined;
            });
          }
        });
      };

    onShowPreflightDlg = () => {
      this.setState({ isShowPreflightDlg: true });
    }

    onClickCreatePortfolioToOpen = (files) => {
      const handle = () => {
        convertController.createNewPortfolioDoc(files, `${intl.get('Portfolio')}.pdf`);
      };
      if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
        handle();
        return;
      }
      const { onShowToSaveBeforeOpen } = store.appStore;
      onShowToSaveBeforeOpen((isToSave) => {
        if (!isToSave) {
          handle();
        }
      });
    }

    onShowFromTemplateDlg =() =>{
      store.appStore.updateShowTemplateDlg(true);
      this.setState({
        messageDlgCfg:{
          onClose: this.onCloseByFromTemplateDlg
        }
      },()=>{
        // const entrance = 'convert';
        // TemplatePluginController.initSrc(entrance)
      })
    }

    onCloseByFromTemplateDlg=()=>{
      store.appStore.updateShowTemplateDlg(false);
  
    }

    onShowCombineFilesDlg = (extra = {}) => {
      this.setState({
        isShowCombineFilesDlg: true,
        messageDlgCfg:{
          onShowToDoDlg:this.props.containerCallbacks.onShowToDoDlg,
          onShowWarningMessage:this.props.containerCallbacks.onShowWarningMessage,
          convertController,
          hasOpenFile: store.viewer.hasOpenFile,
          onCombineFiles: this.onCombineFiles,
          onOk: this.onOkByCombineFilesDlg,
          onCancel: this.onCloseCombineFilesDlg,
          onCovertFileForPreview: this.onCovertFileForPreview,
          onCloseDialog: this.onCloseCombineFilesDlg,
          ...extra
        }
      });
    }

    onCombineFiles(filesList, uploadFailedFiles) {

      let totalSize = 0
      const combineFilesSuccess = (result) => {
        this.onOkByCombineFilesDlg();
  
        if (result && result.ret == 0 && result.url) {
  
  
          const {fileNames} = result.data
  
          if (fileNames || uploadFailedFiles.length) {
            let unsupportedFiles = []
            const failedFiles = uploadFailedFiles
  
            failedFiles.forEach((item) => {
              item.errorType = 'uploadFailed'
              item.name = item.fileName
            });
  
            if (fileNames) {
              unsupportedFiles = fileNames.map((item) => {
                let obj = {name:item,errorType:'brokenFile'}
                return obj
              });
            }
  
  
            this.setState({
              isShowBrokenFileDlgForCombine: true,
              brokenFileList: [...unsupportedFiles, ...failedFiles]
            });
          }
  
          let fileName = convertController.getTargetFileName(filesList[0].name, true, null, '_' + filesList.length + '_combine');
          result.fileName = fileName;
          if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
            const { url } = result;
            fileController.doOpenFileByUrl(url, fileName, () => {
  
            });
  
            return;
          }
  
          this.props.containerCallbacks.onShowToDoDlg(result);
        }
      };
      const doCombine = () => {
        //this.setState({
        //  isSpinForCombineFiles: true,
        //});
        let seqList = filesList.map((file) => {
          let taskId = file.taskId;
          return taskId;
        });
        convertController.doCombineMultifiles(seqList, combineFilesSuccess, (err) => {
          console.error('TCL: onCombineFiles -> err', err);
          if (err.ret === 81000016) {
            const FilesAllBroken = intl.formatMessage({id: 'CombineFiles.Msg.FilesAllBroken'});
  
            store.appStore.setGlobalMessage({ type: 'error', content: FilesAllBroken });
          }
        });
        this.onOkByCombineFilesDlg();
      }
  
      if (filesList.length < 2) {
        return
      }
  
      filesList.forEach(item => {
        let sizeNum = Number(item.size.substring(0, item.size.length - 2));
  
        if (item.size.substring(item.size.length - 2) === 'KB') {
          totalSize += sizeNum / 1024;
        } else {
          totalSize += sizeNum;
        }
      });
  
      if (totalSize > 1024) {
        store.appStore.setGlobalMessage({type: 'warning', content: intl.formatMessage({id: 'CombineFiles.Msg.TotalSizeOver'})});
  
        return
      }
      if (totalSize > 200) {
        this.props.containerCallbacks.onShowWarningMessage((isOk)=>{
          isOk && doCombine()
        }, {message:"CombineFiles.Msg.TotalSizeLarge", title:"CombineFiles.Modal.Title"} );
      } else {
        doCombine()
      }
      //store.taskStore.doCombineMultifiles(filesList, null, combineFilesSuccess);
    }

    onShowMulFiles2PDFDlg = (extra = {})=>{
      this.setState({
        isShowMulFiles2PDFDlg: true,
        messageDlgCfg:{
          onShowToDoDlg:this.props.containerCallbacks.onShowToDoDlg,
          onShowWarningMessage:this.props.containerCallbacks.onShowWarningMessage,
          convertController,
          hasOpenFile: store.viewer.hasOpenFile,
          onOk: this.onOkByCombineFilesDlg,
          onCancel: this.onCloseCombineFilesDlg,
          onCovertFileForPreview: this.onCovertFileForPreview,
          onCloseDialog: this.onCloseCombineFilesDlg,
          ...extra
        }
      });
    }

    onCovertFileForPreview = ({file}) => {
      const doConvert = (resolve) => {
        convertController.doConvertToPDF(file, async (result) => {
          if (result && result!='stop' && result.ret === 0 && result.url) {
            const { fileName, url } = result;
  
            let fileData = null;
            await getFileBufferByUrl(url,res => {
              fileData = new FileData(res, fileName, DATA_TYPE.FileBuffer, '', 0, 0);
            });
            return resolve({ fileName, fileData });
          }
        }, () => {
        });
      }
  
      return new Promise((resolve) => {
        let fileSize = 0;
        if (typeof file.size === 'string' && file.size.substring(file.size.length - 2) === 'KB') {
          fileSize = +file.size.substring(file.size.length - 2) / 1024;
        } else {
          fileSize = +file.size / 1024;
        }
        if (fileSize > 1024) {
          store.appStore.setGlobalMessage({type: 'warning', content: intl.formatMessage({id: 'CombineFiles.Msg.TotalSizeOver'})});
  
          return
        }
        if (fileSize > 200) {
          this.props.containerCallbacks.onShowWarningMessage((isOk)=>{
            isOk && doConvert(resolve);
          }, {message:"CombineFiles.Msg.TotalSizeLarge", title:"CombineFiles.Modal.Title"} );
        } else {
          doConvert(resolve);
        }
      });
    }

    onCloseCombineFilesDlg = (isUseInConvertDlg = false)=>{
      //   store.taskStore.doCleanTaskFileList();
      const { sharepointFileCombinedSuccess, sharepointFileConvertSuccess} = store.appStore.sharePointInfo
  
      if (!sharepointFileCombinedSuccess && !sharepointFileConvertSuccess) {
        store.driveStore.leaveSharePointEditMode()
      }
      
      if (isUseInConvertDlg) return;
  
      this.setState({
        isShowCombineFilesDlg: false,
        isShowMulFiles2PDFDlg:false
      });
    }

    onOkByCombineFilesDlg =(/*result*/)=>{
      this.setState({
        isShowCombineFilesDlg: false,
        isShowMulFiles2PDFDlg:false
      });
    }

    onShowHtml2PDFDlg = (url)=>{
      this.props.containerCallbacks.setState({
        //isShowHtml2PDFDlg:true
        messageDlgCfg:{
          target: DLG_TARGETS.Html2PDF,
          toCache: true,
          config:{
            url,
            onOk: this.onOkByHtml2PDFDlg,
            onClose: this.onCloseByHtml2PDFDlg
          }
        }
      })
    }

    onCloseByHtml2PDFDlg= ()=>{
      this.props.containerCallbacks.setState({
        messageDlgCfg:{
          target:''
        }
        //isShowHtml2PDFDlg:false
      })
    }
    onOkByHtml2PDFDlg = (result)=>{
      //
      const {file, setting} = result;
      this.props.containerCallbacks.setState({
        messageDlgCfg:{
          target:''
        }
        //isShowHtml2PDFDlg:false
      })
      convertController.doHtml2PDF(file, setting, (result)=>{
        if(result && result != 'stop' && result.ret == 0 &&  result.url){
  
          if(!store.viewer.hasOpenFile|| !store.appStore.docModified){
            const { url } = result;
            let fileName = result.data.title ? result.data.title : 'html2pdf.url';
            fileController.doOpenFileByUrl(url, fileName, ()=>{
  
            })
            return;
          }
          this.props.containerCallbacks.onShowToDoDlg(result);
        }
      }, (/*err*/)=>{})
    }
    
    onClickClipboard2PdfToOpen = () => {
      if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
        convertController.doClipboard2PDF();
        return;
      }
      const { onShowToSaveBeforeOpen } = store.appStore;
      onShowToSaveBeforeOpen((isToSave) => {
        if (!isToSave) {
          store.appStore.doUpdateDocModified(false);
          convertController.doClipboard2PDF();
        }
      });
    }

    onClickCreateBlankPdfToOpen = async () => {
      if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
        return this.onClickCreateBlankPdfToOpenInFoxitStorage();
      }
      store.docStore.setDocDriveName("")
      if (createBlankPageThrottle || !window.pdfui) {
        return
      }
      const createNewDoc = () => {
        let title;
        if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
          title = store.storageAppStore.getBlankFileName();
        }
        window.pdfui.createNewDoc(title).then(
          () => {
              const pdfViewer = window.pdfui.pdfViewer;
              pdfViewer.currentPDFDoc.setViewPreference('PageLayout', 'SinglePage');
              pdfViewer.getViewModeManager().switchTo('single-page-view-mode')
          }
        );
      }
  
      if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
        createNewDoc()
        createBlankPageThrottle = true
        setTimeout(() => {
          createBlankPageThrottle = false
        }, 3000)
        return;
      }
      let doc = await window.pdfui.getCurrentPDFDoc();
      let fileName = '';
      if (doc && doc.metadata) {
        fileName = doc.metadata.FileName;
      }
  
      this.props.containerCallbacks.onShowWarningMessage(isOk => {
        if (isOk) {
          fileController.saveToLocal(() => {
            store.appStore.doUpdateDocModified(false);
            createNewDoc();
          });
        } else {
          console.log("ToStopOpen convertTab tsx")
          store.appStore.doUpdateDocModified(false);
          createNewDoc();
        }
      },{ message: 'File.ToStopOpen', messageParams: {FileName: fileName}, cancel: 'No', ok: 'Yes', closable: true, customClose: true, iconType: 'alert' });
    }
    onClickCreateBlankPdfToOpenInFoxitStorage = async () => {
      store.docStore.setDocDriveName("")

      const { onShowToSaveBeforeOpen } = store.appStore;
      const fn = () => {
        const pdfViewer = window.pdfui.pdfViewer;
        pdfViewer.createNewDoc(
          store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage ? 
          store.storageAppStore.getBlankFileName() : 
          `${intl.get('HeaderContainer.untitled')}.pdf`
        ).then(() => {
          if (pdfViewer.currentPDFDoc) {
            pdfViewer.currentPDFDoc.setViewPreference('PageLayout', 'SinglePage');
            pdfViewer.getViewModeManager().switchTo('single-page-view-mode')
          }
        });
      };

      onShowToSaveBeforeOpen((isToSave) => {
        !isToSave && fn();
      });
    }

    handleConvertToPDFExpiredNotify = (isExpired) => {
      let messageKey = "account.expiredTip";
      if(isCNDomain() || isJPDomain()){
        if (!isExpired) {
          messageKey = isCNDomain() ? "account.trialExpiredTip_CN" : "account.trialExpiredTip";
        }
        const successCallback = () => {
          store.userStore.setSubscribeVisible(true);
          this.setState({ isShowConvertToPDFDlg: false });
        }
        this.props.containerCallbacks.onShowWarningMessage((isOk) => { isOk && successCallback() }, { message: messageKey, title: "PhantomPDF.Online.TitleWithOnline", ok: "subscription.plan.Subscribe", noCancel: true });
      }else{
        const {isEdu} = store.userStore;
        if(isEdu){
          // if (!isExpired) {
          //   messageKey = "account.trialExpiredTip";
          // }
          // const successCallback = () => {
          //   store.userStore.setSubscribeVisible(true);
          //   this.setState({ isShowConvertToPDFDlg: false });
          // }
          // this.props.containerCallbacks.onShowWarningMessage((isOk) => { isOk && successCallback() }, { message: messageKey, title: "PhantomPDF.Online.TitleWithOnline", ok: "subscription.plan.Subscribe", noCancel: true });
           window.pdfui.eventEmitter.emit('need-pay-event',true);
        }else{
          window.pdfui.eventEmitter.emit('need-pay-event',true);
        }
      }
    }

    onCloseBrokenFileDlg = () => {
      this.setState({
        isShowBrokenFileDlgForCombine: false,
      })
    }

    onAddCurrentDocForCombineFiles = async ({fileId, success, uploadFailed, fail}) => {
      try {
        let taskList
        let fnIn = await fileController.getFileName();
        if(!fnIn.toLowerCase().endsWith(".pdf")){
          fnIn=fnIn+".pdf"
        }
        
        const fileName = (fnIn) || this.props.containerCallbacks.getOpenFileName();
        const fileSize = (await fileController.getFileSize());
  
        if(fileSize >= 1024 * 1024 * 1024){
          const msg = intl.get('Error.FileLimit',{FileLimit:'1G'});
  
          store.appStore.setGlobalMessage({type: 'error', content: msg});
  
          return;
        }
  
        const metaData = await fileController.getDocMetaData();
        const fileBuffer = (await fileController.getCurrentDocBuffer())[0];
  
        let modifyDate =
          metaData.ModDate ||
          metaData.CreationDate
  
        if(modifyDate){
          if(modifyDate.indexOf("D:")==0){
            modifyDate = modifyDate.substr(2,4)+"/"+modifyDate.substr(6,2)+"/"+modifyDate.substr(8,2)+" "+modifyDate.substr(10,2)+":"+modifyDate.substr(12,2)+":"+modifyDate.substr(14,2)
          }
        }else if (modifyDate==""){
          modifyDate = new Date();
        }
  
        modifyDate = new Date(modifyDate);
        modifyDate = modifyDate.toLocaleDateString()+" "+modifyDate.toTimeString().substr(0,8)
  
        let fileData = new FileData(fileBuffer, fileName, DATA_TYPE.FileBuffer, '', fileId, 0);
  
        // if (fileSize / 1024 / 1024 / 1024  > 1) {
        //   store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'CombineFiles.Msg.SingleFileSizeOver' }) });
  
        //   return;
        // }
  
        taskList = store.taskStore.doUploadMultiFiles([fileData], (result)=>{
          // {ret :1, msg :'Error.UploadingFile.fail', list:[{id:fileUid,taskId:taskUpload.id}]}
          const { ret, msg, list } = result;
  
          if (ret === 1 && msg === 'Error.UploadingFile.fail') {
            // this.onUploadFileFailedCallbackForCombine(list);
            uploadFailed(list);
          }
        });
  
        success && success({fileName, modifyDate, fileSize, taskList,fileData});
      } catch (error) {
        fail && fail();
      }
    }

    onAddDocForCombineFiles = async ({fileArr, success, uploadFailed}) => {
      let taskList
      // let fileList = []
  
      try {
        for (let i = 0; i < fileArr.length; i++) {
          const item = fileArr[i];
          // const fileName = item.fileName
          const fileSize = item.getSize()
          // const fileBuffer = item.buffer
          // const fileId = item.id
  
          if(fileSize >= 1024 * 1024 * 1024){
            const msg = intl.get('Error.FileLimit',{FileLimit:'1G'});
  
            store.appStore.setGlobalMessage({type: 'error', content: msg});
  
            return;
          }
  
          // let fileData = new FileData(fileBuffer, fileName, DATA_TYPE.File, '', fileId);
  
          // fileList.push(fileData)
        }
  
        taskList = store.taskStore.doUploadMultiFiles(fileArr, (result)=>{
          // {ret :1, msg :'Error.UploadingFile.fail', list:[{id:fileUid,taskId:taskUpload.id}]}
          const { ret, msg, list } = result;
  
          if (ret === 1 && msg === 'Error.UploadingFile.fail') {
            // this.onUploadFileFailedCallbackForCombine(list);
            uploadFailed(list);
          }
        });
  
        success({fileArr, taskList})
      } catch (error) {
  
      }
  
    }

    render() 
    {
      const {isShowConvertToPDFDlg,isShowBrokenFileDlgForCombine, isShowMulFiles2PDFDlg, isShowCombineFilesDlg,messageDlgCfg} = this.state;
      const { isShowTemplateDlg} = store.appStore;
      return (
      <React.Fragment>
        {!!isShowConvertToPDFDlg && wrapDialog(<ConvertToPDFDlg visible={isShowConvertToPDFDlg} onExpiredNotify={this.handleConvertToPDFExpiredNotify} changeVisible={value => this.setState({isShowConvertToPDFDlg: value})}/>)}
        {!!isShowBrokenFileDlgForCombine && wrapDialog(<BrokenFileDlg listData={this.state.brokenFileList} title={this.CombineFilesTitle} onOk={this.onCloseBrokenFileDlg}/>)}
        {!!isShowTemplateDlg && wrapDialog(<TemplateDialog visible={isShowTemplateDlg} {...messageDlgCfg}></TemplateDialog>)}
        {!!isShowCombineFilesDlg && (
                  <ContextForCombineFiles.Provider value={{
                    onAddCurrentDoc: this.onAddCurrentDocForCombineFiles,
                    onAddDocFromFileHandler: this.onAddDocForCombineFiles,
                  }}>
                    {wrapDialog(<CombineFiles {...messageDlgCfg} supportConvertDocumentSuffixs={CONVERT_MAP.supportDocumentSuffixs}/>)}
                  </ContextForCombineFiles.Provider>
                )}
        {!!isShowMulFiles2PDFDlg && <ContextForCombineFiles.Provider value={{
                    onAddCurrentDoc: this.onAddCurrentDocForCombineFiles,
                    onAddDocFromFileHandler: this.onAddDocForCombineFiles,
                  }}>{wrapDialog(<MulFiles {...messageDlgCfg} supportConvertDocumentSuffixs={CONVERT_MAP.supportDocumentSuffixs}/>)}</ContextForCombineFiles.Provider>}
        {/* {!!isShowPreflightDlg &&
        <PreflightDlg
          visible={isShowPreflightDlg}
          loading={isShowGlobalSpin}
          changeVisible={value => this.setState({isShowPreflightDlg: value})}
          onLoading={(loading = true) => { this.setState({ isShowGlobalSpin: loading })}}
          onFinished={() => { this.setState({ isShowGlobalSpin: false })}}
        />} */}
      </React.Fragment>
      )
    }
  
}
